export default __webpack_public_path__ + "static/rw-homepage-cdb87b9e5ad47ad3758f0d74bc6fd012.png";